// Generated by ReScript, PLEASE EDIT WITH CARE


function getImage(name) {
  var requireImage = (function(name){
        return require(`PlaceOrderAssetsManager/images/${name}`).default
      });
  return requireImage(name);
}

function importCss(param) {
  return (require(`PlaceOrderAssetsManager/styles/_all.scss`));
}

export {
  getImage ,
  importCss ,
  
}
/* No side effect */
